module.exports = __webpack_public_path__ + "img/dashboard (1).b4ca7b33.png";